import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('toast-container', {
  root: { states: ['stacked'] },
  item: { states: ['hidden', 'exiting'] },
});
